import { useRouter } from 'next/router'
import { useEffect } from 'react'

const useInviteCode = () => {
  const router = useRouter()
  const { f = '', ref = '' } = router.query || {}

  useEffect(() => {
    if (ref) {
      localStorage.setItem('invite_code', ref as string)
    } else if (f) {
      localStorage.setItem('invite_code', f as string)
    }
  }, [f, ref])
}

export default useInviteCode
